import {isEmpty, isNil} from 'ramda';

import type {ActivePreset} from '../types/Api';

export const isPresetColumnsSettingsInvalid = (modifiedPreset: ActivePreset) =>
  isNil(modifiedPreset) ||
  isNil(modifiedPreset.columnsSettings) ||
  isEmpty(modifiedPreset.columnsSettings);
